import { OrderAuditImpl } from "shared/cubiq-model-multi-asset";
import { CoreAudit } from "shared/cubiq-services/model/core/CoreAudit";

export class CoreOrderAudit extends CoreAudit {
  public rawAudit?: OrderAuditImpl;
  public orderId: string;
  public actionSuccess: boolean;
  public traderGroupId: string;
  public traderGroupName: string;
}
